export default "__VITE_PUBLIC_ASSET__16fc7a79__"